export function applyFontSize(elements: HTMLElement[], enabled: boolean) {
  elements.forEach((elem) => {
    // Check if element is still in the DOM and has the required attribute
    if (
      !(elem instanceof HTMLElement) ||
      !elem.isConnected ||
      !elem.dataset.eappsFontSize
    ) {
      return;
    }

    if (!enabled) {
      elem.style.fontSize = '';
      return;
    }

    const prevFontSize = +elem.dataset.eappsFontSize;
    const increaseValue = prevFontSize > 70 ? 10 : 20;
    const newFontSize = (prevFontSize * (increaseValue + 100)) / 100;

    elem.style.fontSize = `${newFontSize}px`;
  });
}
